<div class="form-check gb-check" *ngIf="allowCustomerOptInForMarketing">
    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" (change)="fieldsChange($event)">
    <label class="form-check-label" for="flexCheckDefault">
        {{marketingOptInText}} <br>
        <a (click)="onTermsAndConditions()" *ngIf="addTermsConditions">{{termsAndConditionsText}}</a>
    </label>
</div>


